import { Component } from '@angular/core';
import { LoginModule } from '@inera/common';
import { IDSpinnerModule } from '@inera/ids-angular/components/form/spinner';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [IDSpinnerModule, LoginModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {}
